import axios from "axios";

export default {
  namespaced: true,

  state: {
    user: null
  },

  actions: {
    register({ commit, dispatch }, payload) {
      dispatch("common/setLoading", true, { root: true });
      return new Promise((resolve, reject) => {
        const config = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded"
          }
        };
        axios({
          url: `/user/sign-up?language=${payload.language}`,
          data: {
            username: payload.username,
            password: payload.password
          },
          method: "POST",
          config
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          })
          .finally(() => dispatch("common/setLoading", false, { root: true }));
      });
    },

    login: async ({ commit, dispatch }, user) => {
      dispatch("common/setLoading", true, { root: true });
      return new Promise((resolve, reject) => {
        axios({
          url: `/user/login`,
          data: user,
          method: "POST"
        })
          .then(res => {
            localStorage.setItem(
              "user",
              res.data && res.data.username ? res.data.username : ""
            );
            commit("updateUser", res.data.username);
            resolve(res);
          })
          .catch(err => {
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          })
          .finally(() => dispatch("common/setLoading", false, { root: true }));
      });
    },

    logout: async ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/user/logout`,
          method: "POST"
        })
          .then(res => {
            localStorage.removeItem("user");
            commit("updateUser", null);
            resolve(res);
          })
          .catch(err => {
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    verify: async ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/user/verify?token=${payload.token}&language=${payload.locale}`,
          method: "POST"
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    recover: async ({ commit }, username) => {
      const language = localStorage.getItem("locale");
      const url = language
        ? `/user/forgot-password?language=${language}`
        : `/user/forgot-password`;
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: "POST",
          data: {
            username
          }
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    changePassword: async ({ commit }, payload) => {
      const language = localStorage.getItem("locale");
      const url = language
        ? `/user/change-password?language=${language}`
        : `/user/change-password`;
      return new Promise((resolve, reject) => {
        axios({
          url,
          method: "POST",
          data: payload
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    setNewPassword: async ({ commit }, payload) => {
      return new Promise((resolve, reject) => {
        axios({
          url: `/user/password?language=${payload.language}`,
          method: "PUT",
          data: payload
        })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            const rejectedResponse = err.response ? err.response.data : err;
            reject(rejectedResponse);
          });
      });
    },

    setUser({ commit }, payload) {
      commit("updateUser", payload);
    }
  },

  mutations: {
    updateUser: (state, payload) => {
      state.user = payload;
    }
  }
};
